import React from "react"
import Page from '../components/page'
import Intro from '../components/intro'
import Map from '../components/map'
import TextGrid from '../components/textgrid'
import Slider from '../components/slider'
import Facts from '../components/facts'
import IconGrid from '../components/icongrid'
import Footer from '../components/footer'
import Footnotes from '../components/footnotes'
import Cellular from '../components/cellular'
import Map2 from '../components/map2'


export default function State( props ) {
    const data = props.pageContext
    const intro = data.content.find((content) => content.type === 'intro')
    const map = data.content.find((content) => content.type === 'map')
    const iot = data.content.find((content) => content.type === 'iot')
    const mobilfunk = data.content.find((content) => content.type === 'mobilfunk')
    const festnetz = data.content.find((content) => content.type === 'festnetz')
    const infobox = data.content.find((content) => content.type === 'infobox')

    console.log(map)
    return (
        <Page>
            <Intro {...intro} />
            <Cellular {...infobox} />
            <Map2 
                image={map.background}
                margins={map.margins}
                iot={iot}
                mobilfunk={mobilfunk}
                festnetz={festnetz}
            />

            <Footnotes text={data.footnote} />
            <Footer source={data.source} id={data.id} />
            {(process.env.GATSBY_VF_TRACKING === 'true') && (<><script
                dangerouslySetInnerHTML={{
                __html: `
                    if( typeof( VF ) !== "object" ) VF = {};
                    VF.tealiumUseDCF = true;
                    VF.siteStructure = [ "Über Vodafone", "Netze", "Infografik", "${data.title}" ];
                    VF.pageType = "content";
                    VF.loginStatus = "not logged in";
                    VF.toolBarEnabled = ('yes'==='yes');
                `,
            }}
            />
            <script type="text/javascript" src="//eweb8.vfd2-testnet.de/scripts/s_code.js" defer></script></>)}       
        </Page>
    )
}